import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Input, Select, List, Icon } from 'antd'

import { categories } from '@services/api'

import { categoryType } from '@texts/categories'

@inject((store: any) => {
    const { popupStore, categoriesStore } = store
    return { popupStore, categoriesStore }
})
@observer
export default class AddRelated extends Component<any, any> {
    state = {
        type: undefined,
        list: [],
        filtered: [],
        searchText: ''
    }
    handleChangeType = async type => {
        if (type !== 'RESET') {
            const list = (await categories.getList({ type })).data
            this.setState({ list, type })
            this.filterResults()
        } else {
            this.setState({ list: [], filtered: [], type: undefined })
        }
    }
    filterResults = () => {
        const { list, searchText } = this.state
        const filtered = list.filter(item => item.name.includes(searchText) || item.id.toString() === searchText)
        this.setState({ filtered })
    }
    handleSearchText = async searchText => {
        await this.setState({ searchText })
        this.filterResults()
    }
    attachCategory = async (e, category_ref_id) => {
        e.preventDefault()
        const { popupStore, categoriesStore } = this.props

        categories
            .addRef({ category_id: popupStore.info.id, category_ref_id })
            .then(async res => {
                await categoriesStore.getRelatedCategories(popupStore.info.id)
                this.props.error()
            })
            .catch(e => {
                if (e.response.status === 409) {
                    this.props.error('serverError', 'לא ניתן לשייך אותה קטגוריה פעמיים')
                } else if (e.response.status === 406) {
                    this.props.error('serverError', 'לא ניתן לשייך את הקטגוריה לעצמה')
                } else {
                    this.props.error('serverError', 'קיימת בעיה בהתחברות לשרת')
                }
            })
    }
    render() {
        return (
            <div style={{ padding: '0.5rem', backgroundColor: '#f2f2f2', display: 'flex', flexDirection: 'column' }}>
                <div>
                    <strong style={{ marginBottom: '0.5rem', display: 'block' }}>בחר קטגוריות לשיוך</strong>
                </div>
                <div>
                    <Select
                        style={{ width: '100%' }}
                        onChange={e => this.handleChangeType(e)}
                        placeholder="בחר את סוג הקטגוריה אותה תרצה לשייך"
                        value={this.state.type}
                    >
                        <Select.Option value="RESET">--</Select.Option>
                        <Select.Option value="HEALTH_RIGHT">{categoryType['HEALTH_RIGHT']}</Select.Option>
                        <Select.Option value="POLICY">{categoryType['POLICY']}</Select.Option>
                        <Select.Option value="USER_AREA">{categoryType['USER_AREA']}</Select.Option>
                    </Select>
                </div>
                {this.state.type ? (
                    <div>
                        <Input
                            placeholder="חפש קטגוריה על פי מזהה או שם"
                            value={this.state.searchText}
                            onChange={e => this.handleSearchText(e.target.value)}
                        />
                        <List
                            style={{
                                display: 'block',
                                width: '100%',
                                padding: '0 0.5rem',
                                backgroundColor: 'white'
                            }}
                            itemLayout="vertical"
                            size="small"
                            pagination={{
                                pageSize: 3,
                                size: 'small',
                                hideOnSinglePage: true
                            }}
                            dataSource={this.state.filtered}
                            renderItem={item => (
                                <List.Item key={item.id}>
                                    <strong>{item.name}</strong> | מזהה: {item.id} | {item.parent_id}
                                    <a style={{ float: 'left' }} onClick={e => this.attachCategory(e, item.id)}>
                                        <Icon type="link" /> שייך
                                    </a>
                                </List.Item>
                            )}
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
        )
    }
}
